/**
 * MADAME KA — Promo Progressiva + Urgência
 * Kalles v5.2 — cart-drawer.liquid + /cart
 * =========================================
 * v5.1 — Mensagem resumo no timer (mobile)
 *
 * Regras de desconto:
 * 2 peças + mín R$299 = MADAME8  (8%)
 * 3 peças + mín R$399 = MADAME12 (12%)
 */

(function () {
  'use strict';

  var CFG = {
    frete_gratis_minimo:   499,
    niveis: [
      { pecas: 1, valor_min: 0,   desconto: 0,  cupom: null,       label: 'Preço normal' },
      { pecas: 2, valor_min: 299, desconto: 8,  cupom: 'MADAME8',  label: '8% de desconto' },
      { pecas: 3, valor_min: 399, desconto: 12, cupom: 'MADAME12', label: '12% de desconto' },
    ],
    estoque_min: 3,
    estoque_max: 7,
  };

  function fmt(v) { return 'R$\u00a0' + v.toFixed(2).replace('.', ','); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function getNivel(pecas, valor) {
    var r = CFG.niveis[0];
    CFG.niveis.forEach(function (n) {
      if (pecas >= n.pecas && valor >= n.valor_min) r = n;
    });
    return r;
  }

  function getProximo(pecas, valor) {
    for (var i = 0; i < CFG.niveis.length; i++) {
      var n = CFG.niveis[i];
      if (pecas < n.pecas || valor < n.valor_min) return n;
    }
    return null;
  }

  function getEstoque() {
    var key = 'mk_est_' + new Date().toDateString();
    var v = sessionStorage.getItem(key);
    if (v) return parseInt(v);
    v = Math.floor(Math.random() * (CFG.estoque_max - CFG.estoque_min + 1)) + CFG.estoque_min;
    sessionStorage.setItem(key, v);
    return v;
  }

  function getMeiaNoite() {
    var d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999).getTime();
  }

  function fmtTimer(ms) {
    if (ms <= 0) return '00:00:00';
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function fmtData() {
    var d = new Date();
    return pad(d.getDate()) + '/' + pad(d.getMonth() + 1);
  }

  // ─── CSS ──────────────────────────────────────────────────────────────────
  function injectCSS() {
    if (document.getElementById('mk-promo-css')) return;
    var s = document.createElement('style');
    s.id = 'mk-promo-css';
    s.textContent = [
      '.mk-promo{background:#fff;border:1.5px solid #c9a87c;border-radius:10px;overflow:hidden;margin:10px 0 12px;font-family:sans-serif}',

      // Topo sempre visível — layout em coluna para acomodar a mensagem embaixo
      '.mk-promo__top{background:#1a1a1a;padding:9px 14px 10px;display:flex;flex-direction:column;gap:6px;cursor:pointer;-webkit-tap-highlight-color:transparent;user-select:none}',
      '.mk-promo__top-row{display:flex;align-items:center;justify-content:space-between;gap:8px}',
      '.mk-promo__top-left{flex:1;min-width:0}',
      '.mk-promo__timer-lbl{font-size:10px;color:#aaa;text-transform:uppercase;letter-spacing:.08em;display:block}',
      '.mk-promo__timer-data{font-size:11px;color:#c9a87c;font-weight:500;display:block;margin-top:1px}',
      '.mk-promo__top-right{display:flex;align-items:center;gap:8px;flex-shrink:0}',
      '.mk-promo__timer-cnt{font-size:19px;font-weight:700;color:#fff;letter-spacing:.06em;background:rgba(255,255,255,.1);padding:3px 11px;border-radius:7px;font-variant-numeric:tabular-nums;white-space:nowrap}',
      '.mk-promo__chevron{color:#aaa;font-size:12px;transition:transform .3s ease;line-height:1;flex-shrink:0;display:block}',

      // Mensagem resumo — linha separada abaixo do relógio, só no mobile fechado
      '.mk-promo__timer-resumo{font-size:11px;color:#fff;background:rgba(201,168,124,.18);border-radius:6px;padding:5px 10px;line-height:1.4;display:block;text-align:center}',
      '.mk-promo.mk-expandido .mk-promo__timer-resumo{display:none}',
      '@media(min-width:768px){.mk-promo__timer-resumo{display:none}}',

      // MOBILE: corpo fechado por padrão
      '.mk-promo__corpo{max-height:0;overflow:hidden;transition:max-height .4s ease, opacity .4s ease;opacity:0}',
      '.mk-promo.mk-expandido .mk-promo__corpo{max-height:700px;opacity:1}',
      '.mk-promo.mk-expandido .mk-promo__chevron{transform:rotate(180deg)}',

      // DESKTOP: sempre expandido, sem chevron
      '@media(min-width:768px){',
        '.mk-promo__corpo{max-height:none!important;overflow:visible!important;opacity:1!important}',
        '.mk-promo__chevron{display:none!important}',
        '.mk-promo__top{cursor:default}',
      '}',

      // Estoque
      '.mk-promo__estoque{background:#fff8f0;border-bottom:1px solid #fde8cc;padding:8px 14px;display:flex;align-items:center;gap:8px}',
      '.mk-promo__dot{width:7px;height:7px;background:#ea580c;border-radius:50%;flex-shrink:0;animation:mkDotPulse 1.5s ease-in-out infinite}',
      '@keyframes mkDotPulse{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.5);opacity:.6}}',
      '.mk-promo__est-txt{font-size:12px;color:#92400e;font-weight:500;line-height:1.4}',

      // Níveis
      '.mk-promo__niveis{display:grid;grid-template-columns:repeat(3,1fr);border-bottom:1px solid #f0ece8}',
      '.mk-promo__nivel{padding:10px 6px;text-align:center;border-right:1px solid #f0ece8;transition:background .2s}',
      '.mk-promo__nivel:last-child{border-right:none}',
      '.mk-promo__nivel.mk-ativo{background:linear-gradient(135deg,#fffbf5,#fff5e6)}',
      '.mk-promo__nivel-pecas{font-size:12px;font-weight:600;color:#1a1a1a}',
      '.mk-promo__nivel-desc{font-size:10px;color:#888;margin-top:1px}',
      '.mk-promo__nivel-min{font-size:9px;color:#bbb;margin-top:1px}',
      '.mk-promo__nivel-badge{font-size:10px;font-weight:600;padding:2px 7px;border-radius:10px;margin-top:4px;display:inline-block}',
      '.mk-promo__nivel.mk-ativo .mk-promo__nivel-badge{background:#c9a87c;color:#fff}',
      '.mk-promo__nivel:not(.mk-ativo) .mk-promo__nivel-badge{background:#f0ece8;color:#999}',

      // Primeira compra
      '.mk-promo__primeira{padding:7px 14px;text-align:center;font-size:11px;color:#a16207;background:#fffbf5;border-bottom:1px solid #f0ece8;line-height:1.5}',
      '.mk-promo__primeira strong{color:#1a1a1a}',

      // Frete
      '.mk-promo__frete{padding:10px 14px;border-bottom:1px solid #f0ece8}',
      '.mk-promo__frete-txt{font-size:12px;color:#1a1a1a;margin-bottom:6px;font-weight:500;line-height:1.4}',
      '.mk-promo__frete-txt em{color:#c9a87c;font-style:normal;font-weight:700}',
      '.mk-promo__barra-bg{background:#f0ece8;border-radius:20px;height:6px;overflow:hidden}',
      '.mk-promo__barra-fill{height:100%;border-radius:20px;background:#c9a87c;transition:width .6s ease}',

      // Cupom
      '.mk-promo__cupom{padding:12px 14px;display:none}',
      '.mk-promo__cupom.mk-vis{display:block;animation:mkFadeIn .35s ease}',
      '.mk-promo__cupom-lbl{font-size:10px;text-transform:uppercase;letter-spacing:.1em;color:#a16207;font-weight:600;margin-bottom:7px}',
      '.mk-promo__cupom-row{display:flex;align-items:center;gap:8px}',
      '.mk-promo__cupom-code{flex:1;font-size:18px;font-weight:700;letter-spacing:.1em;color:#1a1a1a;background:#fffbf5;border:1.5px dashed #c9a87c;border-radius:7px;padding:5px 0;text-align:center}',
      '.mk-promo__cupom-btn{background:#1a1a1a;color:#fff;border:none;border-radius:7px;padding:8px 13px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background .2s;font-family:sans-serif}',
      '.mk-promo__cupom-btn:hover{background:#c9a87c}',
      '.mk-promo__cupom-hint{font-size:11px;color:#a16207;margin-top:6px;text-align:center;line-height:1.4}',

      // Falta msg
      '.mk-promo__falta{padding:10px 14px;background:#fffbf0;border-top:1px solid #f5edd8;display:none}',
      '.mk-promo__falta-txt{font-size:12px;color:#a16207;text-align:center;line-height:1.5}',
      '.mk-promo__falta-txt strong{color:#1a1a1a}',

      '.mk-promo-drawer-wrap{position:relative;z-index:10;pointer-events:all}',
      '.mk-promo button, .mk-promo span, .mk-promo div{pointer-events:all}',
      // Esconder segundo lixinho do Kalles (dentro do hdt-tooltip fixo abaixo da quantidade)
      // O primeiro lixinho (dentro do botão minus quando qty=1) continua visível
      '.hdt-mini-cart__actions hdt-tooltip wrapp-remove-item-oncart{display:none!important}',
      // Ajustar posição do lixinho que fica dentro do botão minus (qty=1)
      '.hdt-quantity__button.is--minus wrapp-remove-item-oncart a{margin-top:-8px!important;display:block}',

      '@keyframes mkFadeIn{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:translateY(0)}}',

      // Botão Finalizar Compra — maior e com animação de pulso
      '#ympBtn{',
        'width:100%!important;',
        'padding:18px!important;',
        'font-size:17px!important;',
        'font-weight:700!important;',
        'letter-spacing:.06em!important;',
        'border-radius:50px!important;',
        'animation:mkPulseBtn 2s ease-in-out infinite!important;',
        'box-shadow:0 4px 20px rgba(0,180,150,.4)!important;',
        'cursor:pointer!important;',
      '}',
      '@keyframes mkPulseBtn{',
        '0%,100%{transform:scale(1);box-shadow:0 4px 20px rgba(0,180,150,.4)}',
        '50%{transform:scale(1.03);box-shadow:0 8px 30px rgba(0,180,150,.6)}',
      '}',
    ].join('');
    document.head.appendChild(s);
  }

  // ─── TOGGLE ───────────────────────────────────────────────────────────────
  window.mkToggle = function (idSuffix) {
    if (window.matchMedia('(min-width: 768px)').matches) return;
    var promo = document.getElementById('mk-promo' + (idSuffix || ''));
    if (!promo) return;
    var corpo = promo.querySelector('.mk-promo__corpo');
    if (!corpo) return;
    var expandido = promo.classList.toggle('mk-expandido');
    if (expandido) {
      corpo.style.maxHeight = '700px';
      corpo.style.opacity   = '1';
      corpo.style.overflow  = 'visible';
    } else {
      corpo.style.maxHeight = '0';
      corpo.style.opacity   = '0';
      corpo.style.overflow  = 'hidden';
    }
  };

  // ─── HTML ─────────────────────────────────────────────────────────────────
  function criarHTML(estoque, idSuffix) {
    idSuffix = idSuffix || '';
    return [
      '<div class="mk-promo" id="mk-promo' + idSuffix + '">',

        '<div class="mk-promo__top" onclick="mkToggle(\'' + idSuffix + '\')">',
          '<div class="mk-promo__top-row">',
            '<div class="mk-promo__top-left">',
              '<span class="mk-promo__timer-lbl">&#128293; Promo\u00e7\u00e3o ativa por</span>',
              '<span class="mk-promo__timer-data" id="mk-data' + idSuffix + '">Termina hoje, ' + fmtData() + ' \u00e0s 00:00</span>',
            '</div>',
            '<div class="mk-promo__top-right">',
              '<span class="mk-promo__timer-cnt" id="mk-timer' + idSuffix + '">--:--:--</span>',
              '<span class="mk-promo__chevron">&#9660;</span>',
            '</div>',
          '</div>',
          '<span class="mk-promo__timer-resumo">&#127873; 2 pe\u00e7as acima de R$299 = 8% off &nbsp;&bull;&nbsp; 3+ pe\u00e7as acima de R$399 = 12% off</span>',
        '</div>',

        '<div class="mk-promo__corpo">',

          '<div class="mk-promo__estoque">',
            '<div class="mk-promo__dot"></div>',
            '<span class="mk-promo__est-txt">Aten\u00e7\u00e3o: restam apenas <strong>' + estoque + ' unidades</strong> do seu tamanho!</span>',
          '</div>',

          '<div class="mk-promo__niveis">',
            '<div class="mk-promo__nivel" id="mk-n0' + idSuffix + '">',
              '<div class="mk-promo__nivel-pecas">1 pe\u00e7a</div>',
              '<div class="mk-promo__nivel-desc">Pre\u00e7o normal</div>',
              '<div class="mk-promo__nivel-min">&nbsp;</div>',
              '<div class="mk-promo__nivel-badge">sem desconto</div>',
            '</div>',
            '<div class="mk-promo__nivel" id="mk-n1' + idSuffix + '">',
              '<div class="mk-promo__nivel-pecas">2 pe\u00e7as</div>',
              '<div class="mk-promo__nivel-desc">8% de desconto</div>',
              '<div class="mk-promo__nivel-min">m\u00edn. R$299</div>',
              '<div class="mk-promo__nivel-badge">MADAME8</div>',
            '</div>',
            '<div class="mk-promo__nivel" id="mk-n2' + idSuffix + '">',
              '<div class="mk-promo__nivel-pecas">3+ pe\u00e7as</div>',
              '<div class="mk-promo__nivel-desc">12% de desconto</div>',
              '<div class="mk-promo__nivel-min">m\u00edn. R$399</div>',
              '<div class="mk-promo__nivel-badge">MADAME12</div>',
            '</div>',
          '</div>',

          '<div class="mk-promo__primeira">',
            '&#10024; Primeira compra? Voc\u00ea j\u00e1 ganha <strong>10% de desconto autom\u00e1tico</strong> no checkout!',
          '</div>',

          '<div class="mk-promo__frete">',
            '<div class="mk-promo__frete-txt" id="mk-frete-txt' + idSuffix + '">Calculando...</div>',
            '<div class="mk-promo__barra-bg">',
              '<div class="mk-promo__barra-fill" id="mk-barra' + idSuffix + '" style="width:0%"></div>',
            '</div>',
          '</div>',

          '<div class="mk-promo__cupom" id="mk-cupom' + idSuffix + '">',
            '<div class="mk-promo__cupom-lbl">&#127881; Seu desconto est\u00e1 liberado!</div>',
            '<div class="mk-promo__cupom-row">',
              '<div class="mk-promo__cupom-code" id="mk-code' + idSuffix + '">MADAME8</div>',
              '<button class="mk-promo__cupom-btn" onclick="mkCopiar(\'' + idSuffix + '\')">&#128203; Copiar</button>',
            '</div>',
            '<div class="mk-promo__cupom-hint">Cole este c\u00f3digo no campo de cupom ao finalizar a compra no checkout</div>',
          '</div>',

          '<div class="mk-promo__falta" id="mk-falta' + idSuffix + '">',
            '<div class="mk-promo__falta-txt" id="mk-falta-txt' + idSuffix + '"></div>',
          '</div>',

        '</div>',
      '</div>',
    ].join('');
  }

  // ─── ATUALIZAR UI ─────────────────────────────────────────────────────────
  function atualizarUI(pecas, valor, sfx) {
    sfx = sfx || '';
    var nivel   = getNivel(pecas, valor);
    var proximo = getProximo(pecas, valor);

    for (var i = 0; i < CFG.niveis.length; i++) {
      var el = document.getElementById('mk-n' + i + sfx);
      if (!el) continue;
      el.classList.remove('mk-ativo');
      var n = CFG.niveis[i];
      var isAtivo = (pecas >= n.pecas && valor >= n.valor_min) &&
        (i === CFG.niveis.length - 1 ||
          pecas < CFG.niveis[i + 1].pecas ||
          valor < CFG.niveis[i + 1].valor_min);
      if (isAtivo) el.classList.add('mk-ativo');
    }

    var pct = Math.min(100, Math.round((valor / CFG.frete_gratis_minimo) * 100));
    var barraEl = document.getElementById('mk-barra' + sfx);
    var freteEl = document.getElementById('mk-frete-txt' + sfx);
    if (barraEl) barraEl.style.width = pct + '%';
    if (freteEl) {
      if (valor >= CFG.frete_gratis_minimo) {
        freteEl.innerHTML = '&#127881; Parab\u00e9ns! Voc\u00ea ganhou <em>frete gr\u00e1tis</em>!';
        freteEl.style.color = '#16a34a';
      } else {
        var faltaFrete = CFG.frete_gratis_minimo - valor;
        freteEl.innerHTML = 'Falta <em>' + fmt(faltaFrete) + '</em> para ganhar frete gr\u00e1tis';
        freteEl.style.color = '';
      }
    }

    var cupomEl    = document.getElementById('mk-cupom' + sfx);
    var codeEl     = document.getElementById('mk-code' + sfx);
    var faltaEl    = document.getElementById('mk-falta' + sfx);
    var faltaTxtEl = document.getElementById('mk-falta-txt' + sfx);

    if (nivel.cupom) {
      if (cupomEl) cupomEl.classList.add('mk-vis');
      if (codeEl)  codeEl.textContent = nivel.cupom;
      if (faltaEl) faltaEl.style.display = 'none';
      // Carrinho grande: expandir. Gaveta: nunca abre automático.
      if (sfx === '-cart') {
        var promoEl = document.getElementById('mk-promo' + sfx);
        if (promoEl) {
          promoEl.classList.add('mk-expandido');
          var corpoEl = promoEl.querySelector('.mk-promo__corpo');
          if (corpoEl) {
            corpoEl.style.maxHeight = '700px';
            corpoEl.style.opacity   = '1';
            corpoEl.style.overflow  = 'visible';
          }
        }
      }
    } else {
      if (cupomEl) cupomEl.classList.remove('mk-vis');
      if (proximo && faltaEl && faltaTxtEl) {
        faltaEl.style.display = 'block';
        var partes = [];
        if (pecas < proximo.pecas) {
          var faltaPecas = proximo.pecas - pecas;
          partes.push('<strong>' + faltaPecas + ' pe\u00e7a' + (faltaPecas > 1 ? 's' : '') + '</strong>');
        }
        if (valor < proximo.valor_min) {
          var faltaValor = proximo.valor_min - valor;
          partes.push('<strong>' + fmt(faltaValor) + '</strong> em compras');
        }
        if (partes.length > 0) {
          faltaTxtEl.innerHTML = 'Adicione mais ' + partes.join(' e ') +
            ' e ganhe <strong>' + proximo.desconto + '% de desconto</strong>' +
            ' com o cupom <strong>' + proximo.cupom + '</strong>!';
        }
      }
    }
  }

  // ─── COPIAR ───────────────────────────────────────────────────────────────
  window.mkCopiar = function (sfx) {
    sfx = sfx || '';
    var codeEl = document.getElementById('mk-code' + sfx);
    var btn = codeEl ? codeEl.parentElement.querySelector('.mk-promo__cupom-btn') : null;
    if (!codeEl) return;
    var txt = codeEl.textContent;
    function ok() {
      if (btn) {
        btn.textContent = '\u2713 Copiado!';
        btn.style.background = '#16a34a';
        setTimeout(function () { btn.innerHTML = '&#128203; Copiar'; btn.style.background = ''; }, 2500);
      }
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(txt).then(ok).catch(function () { fbCopy(txt); ok(); });
    } else { fbCopy(txt); ok(); }
  };

  function fbCopy(txt) {
    var ta = document.createElement('textarea');
    ta.value = txt;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  // ─── TIMER ────────────────────────────────────────────────────────────────
  function iniciarTimer() {
    function tick() {
      var resto = Math.max(0, getMeiaNoite() - Date.now());
      var txt  = fmtTimer(resto);
      var data = 'Termina hoje, ' + fmtData() + ' \u00e0s 00:00';
      ['', '-cart'].forEach(function (sfx) {
        var t = document.getElementById('mk-timer' + sfx);
        var d = document.getElementById('mk-data' + sfx);
        if (t) t.textContent = txt;
        if (d) d.textContent = data;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  // ─── BUSCAR CARRINHO ──────────────────────────────────────────────────────
  function buscarCarrinho(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var pecas = 0;
        data.items.forEach(function (i) { pecas += i.quantity; });
        cb(pecas, data.total_price / 100);
      })
      .catch(function () { cb(0, 0); });
  }

  function atualizarTodos() {
    buscarCarrinho(function (p, v) {
      if (document.getElementById('mk-promo'))      atualizarUI(p, v, '');
      if (document.getElementById('mk-promo-cart')) atualizarUI(p, v, '-cart');
    });
  }

  function injetarDrawer() {
    var placeholder = document.getElementById('mk-promo-drawer');
    if (placeholder && !placeholder.querySelector('.mk-promo')) {
      placeholder.innerHTML = criarHTML(getEstoque(), '');
      var promoEl = document.getElementById('mk-promo');
      var corpo = promoEl ? promoEl.querySelector('.mk-promo__corpo') : null;
      if (promoEl && corpo && window.matchMedia('(max-width: 767px)').matches) {
        promoEl.classList.remove('mk-expandido');
        corpo.style.maxHeight = '0';
        corpo.style.opacity   = '0';
        corpo.style.overflow  = 'hidden';
      }
      atualizarTodos();
    }
  }

  function injetarCart() {
    if (window.location.pathname !== '/cart') return;
    if (document.getElementById('mk-promo-cart')) return;
    var targets = ['.cart-page__content', '.hdt-cart-page', 'form[action="/cart"]', '.cart__items'];
    for (var i = 0; i < targets.length; i++) {
      var ref = document.querySelector(targets[i]);
      if (ref && ref.parentNode) {
        var wrap = document.createElement('div');
        wrap.id = 'mk-promo-cart';
        wrap.innerHTML = criarHTML(getEstoque(), '-cart');
        ref.parentNode.insertBefore(wrap, ref);
        var promoEl = document.getElementById('mk-promo-cart');
        var corpo = promoEl ? promoEl.querySelector('.mk-promo__corpo') : null;
        if (promoEl && corpo) {
          promoEl.classList.add('mk-expandido');
          corpo.style.maxHeight = '700px';
          corpo.style.opacity   = '1';
          corpo.style.overflow  = 'visible';
        }
        atualizarTodos();
        return;
      }
    }
  }

  // ─── OBSERVER ─────────────────────────────────────────────────────────────
  function observar() {
    var obs = new MutationObserver(function () { injetarDrawer(); });
    obs.observe(document.body, { childList: true, subtree: true });
    ['cart:updated', 'hdt:cart:updated', 'cart:refresh', 'hdt:cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(atualizarTodos, 300); });
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest
        ? e.target.closest('.hdt-quantity__button, .hdt-qty-btn, [data-quantity-change], .hdt-mini-cart .hdt-btn')
        : null;
      if (btn) setTimeout(atualizarTodos, 600);
    });
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────
  function init() {
    injectCSS();
    injetarDrawer();
    injetarCart();
    iniciarTimer();
    observar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(); 